export default __webpack_public_path__ + "static/media/andrea--tablet@2x.12907473.jpg";